const Types = {
    GET_HOME_POSTS_REQUEST: '/posts/get_home_posts_request',
    GET_HOME_POSTS_SUCCESS: '/posts/get_home_posts_success',
    GET_HOME_POSTS_FAILED: '/posts/get_home_posts_failed',
    SEARCH_POSTS_REQUEST: '/posts/search_posts_request',
    SEARCH_POSTS_SUCCESS: '/posts/search_posts_success',
    SEARCH_POSTS_FAILED: '/posts/search_posts_failed'
};

export default Types;